import React, { useState, useEffect } from 'react';
import { Container, Row,Spinner, Col, Table, Button, Modal, Form, FormControl, Alert } from 'react-bootstrap';
import { FaPen, FaTrash, FaPlus } from 'react-icons/fa';
import { getDesignations, deleteDesignation } from '../services/designationService';
import DesignationForm from './DesignationForm';
import Layout from './Layout';
import TopBar from './TopBar';
const DesignationsList = () => {
  const [designations, setDesignations] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [editingDesignation, setEditingDesignation] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('success');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [designationToDelete, setDesignationToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [error, setError] = useState(null);

  const fetchDesignations = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await getDesignations();
      setDesignations(response.data);
    } catch (error) {
      // Handle different types of errors
      let errorMessage;
      
      // Handle validation errors
      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessages = Object.values(error.response.data.errors).flat();
        errorMessage = errorMessages.join('. ');
      }
      // Handle other API errors
      else if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      }
      // Handle network errors
      else if (error.request) {
        errorMessage = 'Network error: Could not reach the server';
      }
      // Handle other errors
      else {
        errorMessage = error.message || 'An unexpected error occurred';
      }

      setError(error);
      setAlertMessage(errorMessage);
      setAlertVariant('danger');
      setShowAlert(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingDesignation(null);
  };

  const handleDelete = (id) => {
    setDesignationToDelete(id);
    setShowConfirmModal(true);
  };

  const confirmDelete = async () => {
    setDeletingId(designationToDelete);
    setIsLoading(true);
    setError(null);
    
    try {
      await deleteDesignation(designationToDelete);
      setAlertMessage('Designation deleted successfully');
      setAlertVariant('success');
      setShowAlert(true);
      await fetchDesignations();
    } catch (error) {
      // Handle different types of errors
      let errorMessage;
      
      // Handle validation errors
      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessages = Object.values(error.response.data.errors).flat();
        errorMessage = errorMessages.join('. ');
      }
      // Handle other API errors
      else if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      }
      // Handle network errors
      else if (error.request) {
        errorMessage = 'Network error: Could not reach the server';
      }
      // Handle other errors
      else {
        errorMessage = error.message || 'An unexpected error occurred';
      }

      setError(error);
      setAlertMessage(errorMessage);
      setAlertVariant('danger');
      setShowAlert(true);
    } finally {
      setDeletingId(null);
      setIsLoading(false);
      setShowConfirmModal(false);
    }
  };

  const cancelDelete = () => {
    setShowConfirmModal(false);
    setDesignationToDelete(null);
  };

  useEffect(() => {
    fetchDesignations();
  }, []);

  return (
    <Layout>
               <TopBar >  
        
              <Form className="d-none d-md-flex" style={{ width: '250px' }}>
                <FormControl
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="me-2"
                />
              </Form>
          </TopBar>

   <Container fluid>
    <Row>
    {showAlert && (
        <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
          {alertMessage}
        </Alert>
      )}


      <Row className="mt-3">
        <Col className="text-end">
          <Button
            variant="primary"
            onClick={() => {
              setEditingDesignation(null);
              setShowForm(true);
            }}
          >
            <FaPlus className="me-2" /> Add Designation
          </Button>
        </Col>
      </Row>    
    </Row>
   </Container>
    


    <Container  style={{ maxHeight: '80vh', overflowY: 'auto' }}>
   
      

      <Row className="mt-3">
        <Col>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {designations.map(designation => (
                <tr key={designation.id}>
                  <td>{designation.name}</td>
                  <td>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => {
                        setEditingDesignation(designation);
                        setShowForm(true);
                      }}
                      className="me-2"
                    >
                      <FaPen className="me-1" /> Edit
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDelete(designation.id)}
                    >
                      {deletingId === designation.id ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            ) : (
                              <FaTrash className="me-1" />
                            )}
                            Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>

      {showForm && (
        <DesignationForm
          onClose={handleFormClose}
          designation={editingDesignation}
          onSubmit={() => {
            handleFormClose();
            fetchDesignations();
          }}
        />
      )}

      {/* Confirmation Modal */}
      <Modal show={showConfirmModal} onHide={cancelDelete}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this designation? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>
            <FaPen className="me-1" /> Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            {deletingId === designationToDelete ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <FaTrash className="me-1" />
            )}
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
    </Layout>
  );
};

export default DesignationsList;
